export default __webpack_public_path__ + "static/media/17-ART-(2-2).f5202fbc.jpg";